import {useSuspenseQuery} from '@apollo/client'
import {
  CheckoutTotalsSummaryQuery,
  CheckoutTotalsSummaryQueryVariables
} from '@data/__generated__/types.main'
import useWebsiteId from '@hooks/useWebsiteId'
import gql from 'graphql-tag'

export const checkoutTotalsSummaryQuery = gql`
  query checkoutTotalsSummary($websiteId: ID!) {
    userPreferences(websiteId: $websiteId) {
      _id
      deliveryType
      websiteCoinsToSpend
      store {
        _id
        hideTip
      }
      cart {
        amountToPay
        acceptsTip
        couponStatus {
          discount
        }
        realPrice: itemsPrice(includeDiscount: false)
        subtotalWithProductDiscount: itemsPrice(
          includeDiscount: true
          includeCoupon: false
          includeJustoCoins: false
          includeLoyaltyDiscount: false
          includeWebsiteCoins: false
        )

        totalPrice
        calculatedTipAmount
        websiteCoinsToSpend
        loyaltyTransactionStatus {
          transactionId
        }
      }
    }
  }
`

export default function useMoneySummary() {
  const websiteId = useWebsiteId()

  const {data} = useSuspenseQuery<CheckoutTotalsSummaryQuery, CheckoutTotalsSummaryQueryVariables>(
    checkoutTotalsSummaryQuery,
    {
      fetchPolicy: 'cache-and-network',
      variables: {
        websiteId
      }
    }
  )
  return data.userPreferences
}
